import * as React from 'react';
import { withCurrentItemSet, IDecorateWithCurrentItemSetProps } from '../decorators/selectors';
import { WithItemCache, IItemCacheStateProps } from '../withItemCache/WithItemCache';
import { IRenderProps, renderChildrenWithProps } from '../../utilities/components/RenderProps';
import { errorFacet } from '../../facets/DemandFacets';

/**
 * @beta
 */
export interface IWithItemErrorStateProps {
    error?: Error | undefined;
}

/**
 * @beta
 */
export interface IWithItemErrorBaseProps extends IRenderProps<IWithItemErrorStateProps> {
    itemKey?: string | undefined;
}

/**
 * @beta
 */
export class WithItemErrorBase extends React.Component<IWithItemErrorBaseProps> {
    public render(): JSX.Element {
        const {
            children,
            itemKey
        } = this.props;

        return (
            <WithItemCache>
                {
                    ({ itemCache }: IItemCacheStateProps) => {
                        const error = itemCache.isItemFacetResolved(errorFacet, itemKey) ?
                            itemCache.demandItemFacet(errorFacet, itemKey) :
                            undefined;

                        return renderChildrenWithProps(children, {
                            error
                        });
                    }
                }
            </WithItemCache>
        );
    }
}

/**
 * @beta
 */
export type IWithItemErrorProps = IDecorateWithCurrentItemSetProps<IWithItemErrorBaseProps>;

/**
 * @beta
 */
export const WithItemError: React.ComponentType<IWithItemErrorProps> = withCurrentItemSet()(WithItemErrorBase);
